export const ORIGIN_IDS = {
  NORMAL: "25017D0E-F788-48D7-8DC4-62581D58B698",
  RECOMMENDATIONS: "9E016A92-9E5C-4B5B-AC5D-739CEFD6F07B",
} as const;
